// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1H-T0"};